import React from 'react';
import SingIn from './components/SignIn/SignIn';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import AuthProvider from './components/AuthProvider/AuthProvider'
import Chats from './components/Chats/Chats';

const App = () => {
  return (
    <div className="App">
      <Router>
        <AuthProvider>
          <Switch>
            <Route path = '/' component = {SingIn} exact/>

            <Route path = '/chats' component = {Chats} exact/>
          </Switch>
        </AuthProvider>
      </Router>
    </div>
  );
}

export default App;
